<template>
  <div>
    <div v-for="report in activityReports" :key="report.id">
      <div v-if="report.id === $route.params.id">
        <BaseFileViewer
          :title="report.original_name"
          :fileUrl="report.report_file_url"
          :dialog="true"
          :type="report.extension"
          @input="onClose($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseFileViewer from '../../components/base/BaseFileViewer';

export default {
  name: 'ViewFiles',

  components: { BaseFileViewer },

  computed: mapState('activityReports', ['activityReports']),

  methods: {
    onClose(event) {
      if (!event) {
        this.$router.push({ name: 'activityReports' });
      }
    },
  },
};
</script>

<style scoped></style>
